import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {MustMatch} from '../../validators/password.validator';
import { UserService } from '../../services/user.service';
import { AccountService } from '../../services/account.service';
import { AlertService } from '../../shared/services/alert.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  title: string;
  userID: number;
  oldPasswordRequired: boolean;
  closeBtnName: string;
  isOdkAccount: boolean;

  constructor(private formBuilder: FormBuilder, private userService: UserService, private accountService: AccountService,
     private alertService: AlertService , private modalRef: BsModalRef) { }
  ngOnInit() {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: [''],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    }, {
        validator: MustMatch('newPassword', 'confirmPassword')
    });
    if (this.oldPasswordRequired) {
      this.changePasswordForm.controls.oldPassword.setValidators([Validators.required]);
    }
  }
  get f() { return this.changePasswordForm.controls; }

  hideModal() {
   this.modalRef.hide();
  }

  confirm() {
    if (this.changePasswordForm.invalid) {
      return;
    }
   let changePasswordData = { 'newPassword': this.f.newPassword.value, 'userId': this.userID,
     'oldPassword': null};
    if (this.oldPasswordRequired) {
      changePasswordData.oldPassword = this.f.oldPassword.value;

      this.userService.changeOdkPassword(changePasswordData).subscribe(
        response => {
          if (response) {
            this.modalRef.hide();
            this.alertService.success('Password has been successfully changed.');
          }else {
            this.modalRef.hide();
            this.alertService.error('Changing password failed, please check if old password is correct');
          }
        }, err => {
          this.alertService.error('Changing password failed, please try again later');
        }
      );
    } else {
      this.userService.overridePassword(changePasswordData, this.isOdkAccount).subscribe(
        response => {
          if (response) {
            this.modalRef.hide();
            this.alertService.success('Password has been successfully changed.');
          }else {
            this.modalRef.hide();
            this.alertService.error('Changing password failed, please check if old password is correct');
          }
        }, err => {
          this.alertService.error('Changing password failed, please try again later');
        }
      );
    }
  }
}
